import {NgModule} from '@angular/core';
import {MatButtonModule, MatIconModule} from '@cdk/angular/material';

import {NavbarVerticalStyle2Component} from './style-2.component';
import { CdkNavigationComponent } from '@cdk/components/navigation/navigation.component';

@NgModule({
    imports: [
    MatButtonModule,
    MatIconModule,
    CdkNavigationComponent,
    NavbarVerticalStyle2Component
],
    exports: [
        NavbarVerticalStyle2Component
    ]
})
export class NavbarVerticalStyle2Module
{
}
